<template>
  <div v-if="jwtAccessValid() && userProfile.checked && isReciever || isAdmin">

    <acceptances-card v-if="isMobile"/>
    <acceptances-table v-else/>

  </div>
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, onMounted } from "vue"
import { useStore } from 'vuex';
import { useRouter } from 'vue-router'
import useCommonMixin from '@/components/commonMixin.js'
import AcceptancesTable from "./AcceptancesTable.vue";
import AcceptancesCard from "./AcceptancesCard.vue";

export default {
  name: 'Acceptances',
  components: { AcceptancesTable, AcceptancesCard
  },

  setup(props) {
    useCommonMixin()
    const { jwtAccessValid, asyncForEach, isReciever, userProfile, isAdmin, isMobile } = useCommonMixin()
    const store = useStore()
    const router = useRouter()
    const docs = ref([])
    const profiles = ref([{}])

    const init = async () => {
      let response = await store.dispatch('FETCHacceptance')
      docs.value = response.status ? response.data : []
      // asyncForEach(docs.value, async (doc) => {
      //   let response, ind
      //   ind = profiles.value.findIndex(item => item._id == doc.company)
      //   if (ind < 0 ) {
      //     response = await store.dispatch('FETCHuserProfile', {userId: doc.company, phone: null})
      //     profiles.value.push(response)
      //   }
      //   ind = profiles.value.findIndex(item => item._id == doc.deliverer)
      //   if (ind < 0 ) {
      //     response = await store.dispatch('FETCHuserProfile', {userId: doc.deliverer, phone: null})
      //     profiles.value.push(response)
      //   }
      // })
    }

    const getProfile = (profileId) => {
      let profileIndex = profiles.value.findIndex(item => item._id == profileId)
      return (profileIndex >= 0) ? profiles.value[profileIndex] : { company: '', fullname: '' }
    }

    const docSum = (doc) => {
      return Object.values(doc.tableUnit).reduce((a, b) => a + b.weight * b.price, 0)
    }

    onMounted(init)

    return {
      jwtAccessValid,
      isReciever,
      docs,
      getProfile,
      profiles,
      docSum,
      router,
      userProfile,
      isAdmin,
      isMobile,
    }
  }


}

</script>

<style>
</style>

